import React, { useState } from 'react';

import LoginPage from './pages/login/LoginPage';
import TransactionsPage from './pages/transactions/TransactionsPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import { Container } from '@mui/material';
import MenuButton from './MenuButton';

function App() {
  const [currentPage, setCurrentPage] = useState("login");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (password) => {
    const pwd = "lagérance";
    if (password === pwd) {
      setIsAuthenticated(true);
      setCurrentPage("transactions");
    } else {
      alert("Mot de passe incorrect !");
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentPage("login");
  };

  const renderPage = () => {
    if (!isAuthenticated) {
      return <LoginPage onLogin={handleLogin} />;
    }

    if (currentPage === "transactions") {
      return <TransactionsPage />;
    } else if (currentPage === "invoices") {
      return <InvoicesPage />;
    }
  };

  return (
    <>
      <Container sx={{
        padding: 2,
        marginTop: 2,
        maxWidth: {
          xs: "100%", // Écran extra-petit (mobile)
          sm: "600px", // Écran petit (tablette)
          md: "900px", // Écran moyen et plus grand
        },
      }}>
        {isAuthenticated && <MenuButton onNavigate={setCurrentPage} onLogout={handleLogout} />}
        {renderPage()}
      </Container>
    </>
  );
}

export default App;

